/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Integrations {
    angular.module('meevo.plugins.integrations', []);
}